export enum LegalPolicyTypes {
  Privacy = 'privacy-policy',
  TermsOfService = 'terms-service'
}
